import React from 'react';
import Typography from '@material-ui/core/Typography';

const AlertCount = (props) => {
  const { alerts, type } = props;
  const calculateAlertCount = (alerts, type)  => {
    const twoWeeks = parseInt(Date.now()/1000 - 1209600) 
    return type === "response" 
      ? alerts.length 
      : alerts.reduce((acc, alert) => {
        if(alert.time > twoWeeks) {
          acc.push(alert);
        }
        return acc;
      }, []).length;
  }
  const alertCount = calculateAlertCount(alerts, type);
  const range = props.panel === "details" ? " in the last 2 weeks" : ` in the last ${Math.round(props.range / 3600)} hours`;
  const element = (content) => {
    return (
      <Typography
    component="p"
    variant="body2"
    align="right"
    >
    {content}
  </Typography>
    )
  }
  return alertCount > 1
  ? element(alertCount + " alerts" + range)
  : alertCount > 0
    ? element(alertCount + " alert" + range)
    : element("0 alerts" + range);
}

export default AlertCount;


// WEBPACK FOOTER //
// ./src/components/ChartCard/AlertCount.js